import React from 'react';
import {
  Content,
  ErrorBoundary,
  Header,
  Page,
} from '@backstage/core-components';
import { ReleaseChecklistFetch } from './ReleaseChecklistFetch';

/** @public */
export const ReleaseChecklistPage = () => (
  <Page themeId="tool">
    <Header
      title="Release Checklist"
      subtitle="Deployment steps per release"
    />
    <Content>
      <ErrorBoundary>
        <ReleaseChecklistFetch />
      </ErrorBoundary>
    </Content>
  </Page>
);
